// import localUtils from './local/local_util.js';
import React from 'react'
import ApolloClient from "apollo-boost"
import { ApolloProvider } from "react-apollo"
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import MasterForm from './form/masterform.js'
import shapeI from './shape-i.svg'; // Tell Webpack this JS file uses this image
import shapeII from './shape-ii.svg'; // Tell Webpack this JS file uses this image
import logo from './data-broker-logo-white.gif';
import './App.scss'

const client = new ApolloClient({
  uri: "https://www.data-broker.co.uk/graphql"
})

// This is the query that Apollo Client will send to the WP site.
const STEPS_QUERY = gql`
{
  pageBy(uri: "quote-form-steps") {
    id
    acfQuoteFormSteps {
      quoteFormSteps {
        label
        content {
          quoteTextPrefix
          quoteTextPostfix
          valuesTextPrefix
          seperator
          type
          options {
            min
            max
            stepamount
            markers {
              marker
              label
            }
            choices {
              label
            }
            inputs {
              fields {
                label
                type
                isrequired
              }
            }
          }
        }
      }
    }
  }
}
`;

function App() {

  // var xhr = new XMLHttpRequest()
  //
  // xhr.addEventListener('load', () => {
  //   console.log(xhr.responseText)
  // })
  //
  // xhr.open('POST', 'http://databroker.test/zohoPush.php')

  // xhr.send(JSON.stringify({
  //     Full_Name: 'Paul Crookell',
  //     Email: 'Joey Tribiani',
  //     Phone: 'Joey Tribiani',
  //     Channel: 'Joey Tribiani',
  //     Industry: 'Joey Tribiani',
  //     Job_Function: 'Joey Tribiani',
  //     Geography: 'Joey Tribiani',
  //     Company_Size1: 'Joey Tribiani',
  //     Channel: 'Joey Tribiani',
  //     Budget: 'Joey Tribiani',
  //     Additional_Count_Info: 'Joey Tribiani',
  //     Quote_Sentence: 'Joey Tribiani',
  //     GaContent: 'Joey Tribiani',
  //     GaReferURL: 'Joey Tribiani',
  //     GaMedium: 'Joey Tribiani',
  //     GaSource: 'Joey Tribiani',
  //     GaTerm: 'Joey Tribiani',
  //     GaCampaign: 'Joey Tribiani',
  //   }
  // ))

  return (
    <ApolloProvider client={client}>
    <Query query={STEPS_QUERY}>
      {({ loading, error, data }) => {
        if (loading) return <p></p>;
        if (error) return <p>There was an error loading the quote data</p>;
        if (!data.pageBy.acfQuoteFormSteps.quoteFormSteps.length) return <p>No matching posts found.</p>;
        
        return (
          <main className="App">
            <section className="intro">
              {
                /*
                <a href="/" className="site-header__logo">
                  <img src={ logo } alt="Databroker logo" />
                </a>
                */
              }

              <h1 className="h3">Let's find out what data you need...</h1>
              <img src={ shapeI } className="intro__shape intro__shape--left" />
              <img src={ shapeII } className="intro__shape intro__shape--right" />
            </section>
            <MasterForm stepData={ data.pageBy.acfQuoteFormSteps.quoteFormSteps } />
            <img src={ shapeII } className="background-shape" />
          </main>
        )
      }}
      </Query>
    </ApolloProvider>
  );
}

export default App;
